import { hasCancelRequest } from "@/helpers/common";
const actions = {
  async setKPIPackages({ rootState, commit }) {
    const that = this._vm;
    const data = {
      clientID: rootState.common.generalLocalStorageVariables.activeClientID
    }
    const url = 'package/kpi/list';

    try {

      const response = await that.$constants('axios').post(url, data);
      commit('setKPIPackages', response.data);
      commit('common/setApisLoadStates', {api: 'kpiPackages', isLoaded: true}, {root: true});

    } catch (error) {

      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching the kpi packages.Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    }
  },
  async setKPIInsights({ rootState, commit }) {
    const that = this._vm;
    const data = {
      clientID: rootState.common.generalLocalStorageVariables.activeClientID
    }
    const url = 'package/kpi/results';

    try {

      const response = await that.$constants('axios').post(url, data);
      commit('setKPIInsights', response.data);

    } catch (error) {
      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching kpi insights.Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    }finally {
      commit("common/setApisLoadStates", { api: "kpiInsights", isLoaded: true }, { root: true });
    }
  },
  async getEditKPIDetail({ commit, rootState }, taskID) {
    const that = this._vm;
    const url = `v1/task/edit-kpi-detail`;
    const data = {
      activeClientID: rootState.common.generalLocalStorageVariables.activeClientID,
      taskID: taskID
    }
    try {
      const response = await that.$constants('$http').post(url, data);
      return response;
    } catch (error) {
      if (hasCancelRequest(error)) return;
      const notification = {
        code: "urgent",
        title: "An error occurred during loading kpi details.Please refresh the page and try again..",
      }
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async setKPITags({ rootState, commit }) {
    const that = this._vm;
    const data = {
      clientID: rootState.common.generalLocalStorageVariables.activeClientID
    }
    const url = 'package/kpi/tags';

    try {
      commit('common/setApisLoadStates', { api: 'kpiTags', isCalled: true }, { root: true });

      const response = await that.$constants('axios').post(url, data);
      commit('setKPITags', response.data);

    } catch (error) {
      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching kpi tags.Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    } finally {
      commit('common/setApisLoadStates', { api: 'kpiTags', isLoaded: true }, { root: true });
    }
  },
};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/kpis/actions.js